// extracted by mini-css-extract-plugin
module.exports = {"searchDropdownWrapper":"header--search-dropdown_searchDropdownWrapper__Cf8HN"};